import { openBlock as t, createElementBlock as c, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(l, e) {
  return t(), c("svg", r, [...e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      d: "M17.25 8.938h-.875v-1.75A4.377 4.377 0 0 0 12 2.813a4.377 4.377 0 0 0-4.375 4.374v1.75H6.75c-.963 0-1.75.788-1.75 1.75v8.75c0 .963.787 1.75 1.75 1.75h10.5c.962 0 1.75-.787 1.75-1.75v-8.75c0-.962-.788-1.75-1.75-1.75m-7.875-1.75A2.62 2.62 0 0 1 12 4.563a2.62 2.62 0 0 1 2.625 2.625v1.75h-5.25zm7 12.25h-8.75a.88.88 0 0 1-.875-.875v-7c0-.482.394-.876.875-.876h8.75c.481 0 .875.394.875.876v7a.88.88 0 0 1-.875.875M12 16.813c.963 0 1.75-.788 1.75-1.75 0-.963-.787-1.75-1.75-1.75s-1.75.787-1.75 1.75c0 .962.787 1.75 1.75 1.75"
    }, null, -1)
  ])]);
}
const a = { render: n };
export {
  a as default,
  n as render
};
